function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke-width:0.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.354 0.354)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 8.069) rotate(-45)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M10.46,4.755h-3.8V.951a.951.951,0,0,0-1.9,0v3.8H.951a.951.951,0,1,0,0,1.9h3.8v3.8a.951.951,0,1,0,1.9,0v-3.8h3.8a.951.951,0,1,0,0-1.9Z"
})));

var SvgBlackClose = function SvgBlackClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.845,
    height: 16.845,
    viewBox: "0 0 16.845 16.845",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlackClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blackClose.3aec700a.svg";
export { ForwardRef as ReactComponent };